var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showWhenNeeded || _vm.items.length > 1)?_c('v-select',_vm._b({attrs:{"dense":"","hide-details":"","item-text":"description","items":_vm.items,"return-object":""},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},'v-select',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }